import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicyModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden"
      >
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-light text-black">Privacy Policy</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
          >
            ×
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <div className="prose prose-gray max-w-none">
            <p className="text-sm text-gray-500 mb-6">Last updated: January 2025</p>
            
            <h3 className="text-lg font-medium text-black mb-4">1. Information We Collect</h3>
            <p className="text-gray-700 mb-4 font-light">
              We collect information you provide directly to us, such as when you create an account, upload photos, or contact us. This includes your name, email address, and any photos or content you share through our service.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">2. How We Use Your Information</h3>
            <p className="text-gray-700 mb-4 font-light">
              We use the information we collect to provide, maintain, and improve our services, including:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4 font-light">
              <li>Creating and managing your photo albums</li>
              <li>Enabling photo sharing and collaboration features</li>
              <li>Communicating with you about our services</li>
              <li>Protecting against fraud and abuse</li>
            </ul>

            <h3 className="text-lg font-medium text-black mb-4">3. Information Sharing</h3>
            <p className="text-gray-700 mb-4 font-light">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy. We may share your information in the following circumstances:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4 font-light">
              <li>With your explicit consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and prevent fraud</li>
              <li>In connection with a business transfer</li>
            </ul>

            <h3 className="text-lg font-medium text-black mb-4">4. Photo Storage and Security</h3>
            <p className="text-gray-700 mb-4 font-light">
              Your photos are stored securely using industry-standard encryption and security measures. We use Supabase for secure cloud storage and implement appropriate technical and organizational measures to protect your data.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">5. Public Albums</h3>
            <p className="text-gray-700 mb-4 font-light">
              When you create a public album and share the link, anyone with that link can view and upload photos to the album. Please be mindful of what you share and only create public albums for content you're comfortable sharing publicly.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">6. Data Retention</h3>
            <p className="text-gray-700 mb-4 font-light">
              We retain your information for as long as your account is active or as needed to provide you services. You may delete your account and associated data at any time through your account settings.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">7. Your Rights</h3>
            <p className="text-gray-700 mb-4 font-light">
              You have the right to access, update, or delete your personal information. You can manage your data through your account settings or by contacting us directly.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">8. Cookies and Tracking</h3>
            <p className="text-gray-700 mb-4 font-light">
              We use essential cookies to provide our services and maintain your session. We do not use tracking cookies or third-party analytics that compromise your privacy.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">9. Children's Privacy</h3>
            <p className="text-gray-700 mb-4 font-light">
              Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us immediately.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">10. Changes to This Policy</h3>
            <p className="text-gray-700 mb-4 font-light">
              We may update this privacy policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last updated" date.
            </p>

            <h3 className="text-lg font-medium text-black mb-4">11. Contact Us</h3>
            <p className="text-gray-700 mb-4 font-light">
              If you have any questions about this privacy policy or our practices, please contact us through our website at{' '}
              <a 
                href="https://www.angrybranding.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black hover:underline"
              >
                www.angrybranding.com
              </a>
              .
            </p>

            <div className="bg-gray-50 rounded-lg p-4 mt-8">
              <h4 className="font-medium text-black mb-2">Beta Notice</h4>
              <p className="text-sm text-gray-600 font-light">
                During our beta period, we may collect additional feedback and usage data to improve our service. This data is used solely for product development and is handled according to the same privacy standards outlined above.
              </p>
            </div>
          </div>
        </div>
        
        <div className="p-6 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="w-full bg-black text-white py-3 px-6 rounded-md hover:bg-gray-800 transition-all font-medium"
          >
            Close
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicyModal;